let BASE_URL, OMNICURIS_URL, PARTNER_BASE_URL, COURSE_SERVICE_BASE_URL, COMMONS_SERVICE_BASE_URL;
let MODERATOR_SERVICE_BASE_URL;
let SUPER_SIMPLE_AUTH_ORG_IDS

if (process.env.REACT_APP_ENV === 'development') {
    BASE_URL = 'https://stgapi.omnicuris.com/';
    OMNICURIS_URL = 'https://stg.omnicuris.com';
    PARTNER_BASE_URL = 'https://partnerstgapi.omnicuris.com/';
    COURSE_SERVICE_BASE_URL = 'https://stg-course-api.omnicuris.com/api/';
    // COURSE_SERVICE_BASE_URL = 'http://localhost:8210/api/';
    COMMONS_SERVICE_BASE_URL = 'https://stg-commons-api.omnicuris.com/api/';
    MODERATOR_SERVICE_BASE_URL = 'https://stg-moderator-api.omnicuris.com/api/';
    SUPER_SIMPLE_AUTH_ORG_IDS = [589]
}
if (process.env.REACT_APP_ENV === 'pre-production') {
    BASE_URL = 'https://preprodapi.omnicuris.com/';
    OMNICURIS_URL = 'http://preprod.omnicuris.com';
    PARTNER_BASE_URL = 'https://partnerapi-preprod.omnicuris.com/';
    COURSE_SERVICE_BASE_URL = 'https://preprod-course-api.omnicuris.com/api/';
    COMMONS_SERVICE_BASE_URL = 'https://preprod-commons-api.omnicuris.com/api/';
    MODERATOR_SERVICE_BASE_URL = 'https://preprod-moderator-api.omnicuris.com/api/';
    SUPER_SIMPLE_AUTH_ORG_IDS = [637]
}
if (process.env.REACT_APP_ENV === 'production') {
    BASE_URL = 'https://api.omnicuris.com/';
    OMNICURIS_URL = 'https://www.omnicuris.com';
    PARTNER_BASE_URL = 'https://partnerapi.omnicuris.com/';
    COURSE_SERVICE_BASE_URL = 'https://course-api.omnicuris.com/api/';
    COMMONS_SERVICE_BASE_URL = 'https://commons-api.omnicuris.com/api/';
    MODERATOR_SERVICE_BASE_URL = 'https://moderator-api.omnicuris.com/api/';
    SUPER_SIMPLE_AUTH_ORG_IDS = [637]
}

export {
    BASE_URL,
    OMNICURIS_URL,
    PARTNER_BASE_URL,
    COURSE_SERVICE_BASE_URL,
    COMMONS_SERVICE_BASE_URL,
    MODERATOR_SERVICE_BASE_URL,
    SUPER_SIMPLE_AUTH_ORG_IDS
};

export const APP_VERSION = '1.4.0';
